import GuideLayout from '@app/modules/GuideV2/layout/guide.layout'
import { lazy } from 'react'
import { Navigate, Route } from 'react-router-dom'
import { withSuspense } from '@app/lib/withSuspense'

const GlossaryPage = lazy(() => import('@app/components/Pages/Guide/GlossaryPage'))
const GuideContentPage = lazy(() =>
  import('@app/components/Pages/Guide/GuideContentPage').then((m) => ({
    default: m.GuideContentPage,
  })),
)
const GuideGetStartedPage = lazy(() =>
  import('@app/modules/GuideV2/pages/get-started.page').then((m) => ({
    default: m.GuideGetStartedPage,
  })),
)
const SubTopicTemplatePage = lazy(() => import('@app/modules/GuideV2/pages/subTopicTemplate.page'))
const TopicLandingPage = lazy(() => import('@app/modules/GuideV2/pages/guideTopicLanding.page'))

export default function GuideRoutes() {
  return (
    <Route path="guide" element={<GuideLayout />}>
      <Route index element={<Navigate to="get-started" replace />} />
      <Route path="get-started" element={withSuspense(<GuideGetStartedPage />)} />
      <Route path="glossary" element={withSuspense(<GlossaryPage />)} />
      <Route path=":mainTopic" element={withSuspense(<TopicLandingPage />)} />
      <Route path=":mainTopic/:subTopic" element={withSuspense(<SubTopicTemplatePage />)} />
      <Route
        path=":mainTopic/:subTopic/:articleSlug"
        element={withSuspense(<GuideContentPage />)}
      />
    </Route>
  )
}
